import ActionsForm from '@/shared/mixins/actionsForm'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm],
  name: 'CustomerTable',
  data () {
    return {
      headTable: ['NOME', 'CPF', 'RG', 'STATUS', 'DT. DE CADASTRO', ''],
      customersArray: [],
      filter: localStoreHelper.gestao.cliente() || {},
      isFilter: false
    }
  },
  methods: {
    selectUser () {
      this.$emit('selectUser')
    },
    deleteCustomer () {
      this.$emit('deleteCustomer')
    },
    verificaLocalStoreHelper () {
      this.isFilter = localStoreHelper.gestao.cliente() != null ? 1 : false
    },
    onLoad () {
      this.verificaLocalStoreHelper()
      if (this.isFilter) {
        usermanagement.GetClientesByFiltro(this.$refs.tableCustomersGrid.pagingLimit, this.$refs.tableCustomersGrid.pagingIndex, this.filter)
          .then(res => {
            if (res.status === 200) {
              let newUsersArray = res.data.data
              let newResponse = res
              this.customersArray = newUsersArray
              this.$refs.tableCustomersGrid.LoadAllByData(newResponse)
            }
          })
          .catch(() => {})
        return
      }
      usermanagement.GetAllClientes(this.$refs.tableCustomersGrid.pagingLimit, this.$refs.tableCustomersGrid.pagingIndex)
        .then(res => {
          this.customersArray = res.data.data
          this.$refs.tableCustomersGrid.LoadAllByData(res)
        })
        .catch(() => {})
    },
    searchWithFilter (filter, isFilter) {
      this.filter = filter
      this.isFilter = isFilter
      if (!this.isFilter) {
        this.$refs.tableCustomersGrid.pagingIndex = 1
        this.$refs.tableCustomersGrid.currentPage = 1
      }
      usermanagement.GetClientesByFiltro(this.$refs.tableCustomersGrid.pagingLimit, this.$refs.tableCustomersGrid.pagingIndex, filter)
        .then(res => {
          if (res.status === 200) {
            let newUsersArray = res.data.data
            let newResponse = res
            this.customersArray = newUsersArray
            this.$refs.tableCustomersGrid.LoadAllByData(newResponse)
          }
        })
        .catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/components/CustomerTable/CustomerTable.js